import { render, staticRenderFns } from "./YvIndex.vue?vue&type=template&id=08d76bd4&scoped=true&"
import script from "./YvIndex.vue?vue&type=script&lang=js&"
export * from "./YvIndex.vue?vue&type=script&lang=js&"
import style0 from "./YvIndex.vue?vue&type=style&index=0&id=08d76bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d76bd4",
  null
  
)

export default component.exports